import axios from "axios";
import { toast } from "@/hooks/use-toast";
import CONFIG from "../config";

const authapi = axios.create({
    timeout: 10000,
    baseURL: CONFIG.authApi,
});

authapi.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("access-token");
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

authapi.interceptors.response.use(
    (res) => res,
    async (error) => {
        const { status, response } = error;

        let data = response?.data;

        if (data instanceof Blob) {
            try { data = JSON.parse(await data.text()) } catch { data = null }
        }

        switch (status) {
            case 400:
                if (data?.ExceptionMessage) {
                    toast({
                        title: "Hata (400)",
                        description: data.ExceptionMessage,
                        variant: "destructive"
                    });
                }
                break;
            case 422:
                toast({
                    title: "Doğrulama Hatası (422)",
                    description: data?.Message || "Gönderilen veri formatı geçersiz.",
                    variant: "destructive"
                });
                break;
            case 500:
                toast({
                    title: "Sunucu Hatası (500)",
                    description: data?.ExceptionMessage || "Beklenmedik bir sunucu hatası oluştu.",
                    variant: "destructive"
                });
                break;
            case 401:
                toast({
                    title: "Yetkisiz Erişim (401)",
                    description: "Oturumunuz sonlanmış veya geçersiz.",
                    variant: "destructive"
                });
                break;
            default:
                toast({
                    title: "Bağlantı Hatası",
                    description: "Bağlantı başarısız, İnternet bağlantınızı kontrol edin.",
                    variant: "destructive"
                });
                break;
        }

        return Promise.reject(error);
    }
);

export default authapi;